import axios from '../axiosClient';
export var getProject = function (idProject) { return axios.get("/public/project/".concat(idProject)); };
export var investLand = function (payload) { return axios.post('/invest-landing-page', payload); };
